<script setup lang="ts">
defineProps<{
  messages: string[]
}>()
</script>

<template>
  <Message v-if="messages.length" severity="error" size="small">
    <span v-for="message in messages" :key="message" class="block">{{ message }}</span>
  </Message>
</template>
